"use client";

import React, { useTransition } from "react";
import { Button } from "../ui/button";
import { Trash } from "lucide-react";
import { removeItemFromCart } from "@/services/cart.service";
import toast from "react-hot-toast";
import { useTranslations } from "next-intl";

const DeleteFromCart = ({ productId }: { productId: number }) => {
  const [isPending, startTransition] = useTransition();
  const t = useTranslations();

  const handleDelete = () => {
    startTransition(async () => {
      try {
        await removeItemFromCart(productId);
        toast.success(t("deletedSuccessfully"));
      } catch (err) {
        console.log(err);
      }
    });
  };

  return (
    <Button
      variant="link"
      size="icon"
      className="text-red-500"
      loading={isPending}
      onClick={handleDelete}
    >
      <Trash />
    </Button>
  );
};

export default DeleteFromCart;
